// import { FC, useEffect, useState } from 'react'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
// import { sendEmailVerification } from 'firebase/auth'
// import type { FirebaseError } from 'firebase/app'
// import { toast } from 'react-toastify'
// import { useNavigate } from 'react-router-dom'
// import { auth } from '../../../../../firebase'

// export const ResentValidationEmail: FC = () => {
//   const navigate = useNavigate()
//   const [isValidated, setIsValidated] = useState(false)
//   const [isSending, setIsSending] = useState(false)

//   // ⏱️ En lugar de un booleano, guardamos "hasta cuándo" dura el cooldown.
//   // Lazy init: al montar, queda deshabilitado por 2 minutos desde AHORA.
//   const [cooldownUntil, setCooldownUntil] = useState(() => Date.now() + 120_000)

//   // "Reloj" que fuerza el re-render cada segundo para reevaluar el cooldown
//   const [now, setNow] = useState(Date.now())
//   useEffect(() => {
//     const id = setInterval(() => setNow(Date.now()), 1000)
//     return () => clearInterval(id)
//   }, [])

//   // Poll: recarga el user de Firebase para detectar verificación
//   useEffect(() => {
//     const interval = setInterval(async () => {
//       const currentUser = auth.currentUser
//       if (currentUser) {
//         await currentUser.reload()
//         if (currentUser.emailVerified) {
//           setIsValidated(true)
//           clearInterval(interval)
//         }
//       }
//     }, 1000)
//     return () => clearInterval(interval)
//   }, [])

//   useEffect(() => {
//     if (isValidated) {
//       navigate('/auth/complete-signup', { replace: true })
//     }
//   }, [isValidated, navigate])

//   const resendCode = async () => {
//     const currentUser = auth.currentUser
//     if (!currentUser) {
//       toast.error('No hay sesión activa. Inicia sesión e inténtalo de nuevo.')
//       return
//     }
//     if (currentUser.emailVerified) {
//       toast.info('Tu correo ya está verificado.')
//       return
//     }

//     setIsSending(true)
//     try {
//       await toast.promise(
//         // Opcional: configura la URL de retorno si usas deep-link o flow in-app
//         sendEmailVerification(currentUser, {
//           url: `${window.location.origin}/auth/complete-signup`,
//           handleCodeInApp: true
//         }),
//         {
//           pending: 'Enviando correo de verificación…',
//           success: 'Hemos enviado un correo de verificación 👌',
//           error: {
//             render({ data }) {
//               const e = data as FirebaseError | undefined
//               switch (e?.code) {
//                 case 'auth/too-many-requests':
//                   return 'Demasiados intentos. Intenta nuevamente más tarde.'
//                 case 'auth/requires-recent-login':
//                   return 'Por seguridad, vuelve a iniciar sesión y reintenta.'
//                 case 'auth/user-disabled':
//                   return 'La cuenta está deshabilitada.'
//                 case 'auth/network-request-failed':
//                   return 'Problema de red. Revisa tu conexión.'
//                 default:
//                   return 'No se pudo enviar el correo 🤯'
//               }
//             }
//           }
//         }
//       )
//     } finally {
//       setIsSending(false)
//     }
//   }
//   // 👉 Al hacer click: si no hay cooldown ni envío en curso,
//   //    arrancamos OTROS 2 minutos y seguimos el flujo normal.
//   const handleClick = () => {
//     const inCooldown = now < cooldownUntil
//     if (inCooldown || isSending) return
//     setCooldownUntil(Date.now() + 120_000) // deshabilita 2 min desde ahora
//     void resendCode()
//   }

//   // 🔒 Botón deshabilitado si ahora es menor a cooldownUntil o si está enviando
//   const disabled = now < cooldownUntil || isSending
//   return (
//     <div className='flex flex-col gap-6 justify-between mt-6 w-2/3 mx-auto'>
//       <div className='mb-6'>
//         <h3 className='mb-3 text-3xl font-bold text-center'>Te enviamos un correo</h3>
//         <p>
//           Necesitamos validar tu cuenta, revisa tu bandeja de entrada. ¿No te llegó el correo?
//           Revisa SPAM o haz clic en el botón para reenviarlo.
//         </p>
//       </div>
//       {now < cooldownUntil && (
//         <p className='text-center text-sm text-muted-foreground'>
//           Por favor esperar un momento y revisar el spam de los correos.
//         </p>
//       )}
//       <div className='flex flex-col gap-2 mt-12 w-2/3 mx-auto'>
//         <div className='flex items-center justify-center gap-8'>
//           <button
//             onClick={handleClick}
//             type='button'
//             className='btn-primary rounded-full disabled:opacity-60'
//             disabled={disabled}
//           >
//             <span>{isSending ? 'Enviando…' : 'Reenviar'}</span>
//             <FontAwesomeIcon className="" size='lg' icon={faPaperPlane} />
//           </button>
//         </div>
//       </div>
//       <br />
//       <p className='text-center'>
//         En caso de problemas, contactate con el equipo a{' '}
//         <span className='text-accent1'>soporte@tryluca.cl</span>
//       </p>
//     </div>
//   )
// }
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { sendEmailVerification, onAuthStateChanged } from 'firebase/auth'
import type { FirebaseError } from 'firebase/app'
import { sileo } from 'sileo'
import { auth } from '../../../../../firebase'
import { useNavigate } from 'react-router-dom'
import { OrganizationAPI } from '../../../../../api/organization.api'
import { UserAuth } from '../../../../../context/AuthContext'
import { REGISTRATION_STATUS } from '../../../../../utils/authSession'
import { pushGtmEvent } from '../../../../../utils/gtm'

const DEFAULT_COOLDOWN_MS = 120_000 // 2 minutos (tu UX)
const RATE_LIMIT_COOLDOWN_MS = 600_000 // 10 minutos si Firebase devuelve too-many-requests
const organizationApi = new OrganizationAPI()

const authActionBaseUrls: Record<string, string> = {
  production: 'https://gcp-prod-465219.web.app',
  beta: 'https://gcp-beta-503317.web.app',
  development: 'https://gcp-dev-465219.web.app'
}

const getAuthActionBaseUrl = () => {
  const env = process.env.REACT_APP_ENVIRONMENT || 'development'
  return authActionBaseUrls[env] || window.location.origin
}

const getEmailVerificationActionSettings = () => ({
  url: `${getAuthActionBaseUrl()}/auth/action`,
  handleCodeInApp: true
})

type ResentValidationEmailProps = {
  isActive?: boolean
}

export const ResentValidationEmail: FC<ResentValidationEmailProps> = ({ isActive = true }) => {
  const [isValidated, setIsValidated] = useState(false)
  const [isSending, setIsSending] = useState(false)
  const [verificationError, setVerificationError] = useState(false)
  const isVerifyingOrganizationRef = useRef(false)
  const hasTriedOrganizationVerificationRef = useRef(false)
  const hasFiredEmailVerifiedEventRef = useRef(false)
  const { refreshBackendSession } = UserAuth()
  const navigate = useNavigate()

  // ⏱️ Guardamos CUÁNDO termina el cooldown (timestamp ms)
  const [cooldownUntil, setCooldownUntil] = useState<number>(() => Date.now() + DEFAULT_COOLDOWN_MS)
  const verifyOrganization = useCallback(async () => {
    if (
      isVerifyingOrganizationRef.current ||
      hasTriedOrganizationVerificationRef.current
    ) {
      return false
    }

    const currentUser = auth.currentUser
    if (!currentUser?.uid || !currentUser.email) return false

    isVerifyingOrganizationRef.current = true
    hasTriedOrganizationVerificationRef.current = true
    try {
      await organizationApi.verification({
        uid: currentUser.uid,
        email: currentUser.email
      })
      localStorage.removeItem('firebaseVerificationCredential')
      setVerificationError(false)
      return true
    } catch (error) {
      setVerificationError(true)
      return false
    } finally {
      isVerifyingOrganizationRef.current = false
    }
  }, [])

  const checkEmailVerification = useCallback(async () => {
    if (isValidated || verificationError) return

    const currentUser = auth.currentUser
    if (!currentUser) return

    await currentUser.reload()
    if (currentUser.emailVerified) {
      if (!hasFiredEmailVerifiedEventRef.current) {
        hasFiredEmailVerifiedEventRef.current = true
        pushGtmEvent({ event: 'email_verified' })
      }

      const organizationVerified = await verifyOrganization()
      if (!organizationVerified) return

      const session = await refreshBackendSession(currentUser)
      if (session.registrationStatus !== REGISTRATION_STATUS.COMPLETED) {
        setVerificationError(true)
        return
      }

      localStorage.removeItem('isValidated')
      setIsValidated(true)
    }
  }, [isValidated, refreshBackendSession, verificationError, verifyOrganization])

  // “Reloj” para forzar re-render y actualizar contador/disabled
  const [now, setNow] = useState<number>(Date.now())
  useEffect(() => {
    if (!isActive) return

    setNow(Date.now())
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [isActive])

  // Al montar y cuando cambie el usuario, respetar cooldown persistido (si existe) o iniciar uno nuevo
  useEffect(() => {
    if (!isActive) return

    const applyFromStorage = (uid?: string | null) => {
      const key = `verifyCooldown:${uid ?? 'anon'}`
      const persisted = Number(localStorage.getItem(key) || 0)
      if (persisted > Date.now()) {
        setCooldownUntil(persisted) // respetar cooldown vigente
      } else {
        // iniciar cooldown “de bienvenida” cada vez que entras acá
        const until = Date.now() + DEFAULT_COOLDOWN_MS
        setCooldownUntil(until)
        localStorage.setItem(key, String(until))
      }
    }

    // 1) Aplicar de inmediato con el estado actual (aunque aún no haya usuario)
    applyFromStorage(auth.currentUser?.uid ?? null)

    // 2) Re-aplicar cuando el auth termine de cargar/cambie
    const unsub = onAuthStateChanged(auth, u => {
      applyFromStorage(u?.uid ?? null)
    })
    return () => unsub()
  }, [isActive])

  // Poll: recarga el user de Firebase para detectar verificación
  useEffect(() => {
    if (!isActive) return

    void checkEmailVerification()
    const interval = setInterval(checkEmailVerification, 1000)
    return () => clearInterval(interval)
  }, [checkEmailVerification, isActive])

  useEffect(() => {
    if (!isActive) return

    const handleVerificationSignal = () => {
      void checkEmailVerification()
    }
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void checkEmailVerification()
      }
    }
    const handleStorage = event => {
      if (event.key === 'isValidated' && event.newValue === 'true') {
        void checkEmailVerification()
      }
    }

    window.addEventListener('focus', handleVerificationSignal)
    window.addEventListener('storage', handleStorage)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('focus', handleVerificationSignal)
      window.removeEventListener('storage', handleStorage)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [checkEmailVerification, isActive])

  useEffect(() => {
    if (isValidated) {
      navigate('/complete-signup/poll-sii', { replace: true })
    }
  }, [isValidated, navigate])

  const setAndPersistCooldown = (ms: number) => {
    const until = Date.now() + ms
    setCooldownUntil(until)
    const uid = auth.currentUser?.uid ?? 'anon'
    localStorage.setItem(`verifyCooldown:${uid}`, String(until))
  }

  const resendCode = async () => {
    const currentUser = auth.currentUser
    if (!currentUser) {
      sileo.error({
        title: 'Sesión Requerida',
        description: (
          <span className='text-red-500/80 font-medium'>
            No hay sesión activa. Inicia sesión e inténtalo de nuevo.
          </span>
        )
      })
      return
    }
    if (currentUser.emailVerified) {
      if (verificationError) {
        hasTriedOrganizationVerificationRef.current = false
        setVerificationError(false)
        void checkEmailVerification()
        return
      }

      sileo.info({
        title: 'Correo Verificado',
        description: (
          <span className='text-blue-500/80 font-medium'>Tu correo ya está verificado.</span>
        )
      })
      return
    }

    // Si aún está en cooldown, no golpees Firebase
    if (now < cooldownUntil) return

    // Arrancar cooldown UX de 2 minutos cada intento (y persistir)
    setAndPersistCooldown(DEFAULT_COOLDOWN_MS)

    setIsSending(true)
    try {
      await sendEmailVerification(currentUser, getEmailVerificationActionSettings())

      sileo.success({
        title: 'Correo Enviado',
        description: (
          <span className='text-white font-medium'>
            Hemos enviado un correo de verificación 👌
          </span>
        )
      })
    } catch (err) {
      const e = err as FirebaseError
      if (e?.code === 'auth/too-many-requests') {
        // Backoff más largo y persistido: evita pelear con Firebase hasta que pase el rate-limit real
        setAndPersistCooldown(RATE_LIMIT_COOLDOWN_MS)
        sileo.info({
          title: 'Límite Alcanzado',
          description: (
            <span className='text-blue-500/80 font-medium'>
              Has alcanzado el límite de reintentos. Intenta nuevamente en unos minutos.
            </span>
          )
        })
      }
    } finally {
      setIsSending(false)
    }
  }

  // Estado visual
  const disabled = (now < cooldownUntil && !verificationError) || isSending
  const remainingMs = Math.max(0, cooldownUntil - now)

  const fmt = (ms: number) => {
    const totalSec = Math.ceil(ms / 1000)
    const m = Math.floor(totalSec / 60)
      .toString()
      .padStart(2, '0')
    const s = (totalSec % 60).toString().padStart(2, '0')
    return `${m}:${s}`
  }

  return (
    <div
  className='flex flex-col gap-3 justify-between mt-6 w-full mx-auto px-2 sm:px-0
    text-white sm:text-gray-800
  '
>
  <div className='mb-3 w-full'>
    <p className="font-sans text-justify text-left text-white/70 sm:text-gray-600 text-lg w-full">
      Te enviamos un correo a tu bandeja de entrada. Ábrelo y haz clic en el enlace para confirmar tu cuenta.
      Puede tardar unos segundos en llegar. Si no lo encuentras, revisa 
      <span className="font-sans font-semibold text-white sm:text-gray-800"> SPAM </span> 
      o 
      <span className="font-sans font-semibold text-white sm:text-gray-800"> Promociones</span>.
    </p>
    {verificationError && (
      <p className='mt-4 text-sm font-medium text-red-500'>
        Tu correo ya fue verificado, pero no pudimos activar la empresa. Intenta nuevamente en unos segundos.
      </p>
    )}
  </div>

  {/* 🔹 Solo botón */}
  <div className='flex flex-col gap-2 mt-12 w-full mx-auto'>
    <div className='flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8'>
      <button
        onClick={resendCode}
        type='button'
        className="w-full py-4 rounded-xl bg-primary text-white font-semibold text-sm shadow-md"
        disabled={disabled}
      >
        <span>
          {isSending
            ? 'Enviando…'
            : verificationError
            ? 'Reintentar activación'
            : disabled
            ? `Reenviar correo (${fmt(remainingMs)})`
            : 'Reenviar correo'}
        </span>
      </button>
    </div>
  </div>

  <br />
</div>
  )
}
